<div class="image-viewer-container">
  <angular-image-viewer
  #viewer
  [src]="src"
  [config]="setting"
  (customImageEvent)="handleEvent($event)"
  [(index)]="imageIndex">
  </angular-image-viewer>
</div>
